import React, { useRef, useState } from "react";
import "./index.css";
import { useDispatch } from "react-redux";
import ICONS from "../../../assets/Icons";
import SVGComponent from "../../_utils/SVGComponent";
import IconRoundButton from "../../_utils/CommonButtons/IconRoundButton";
import { IntervalConfiguration } from "../../../utils/configurationProvider";
import { checkUsertoken } from "../../../redux/features/login/login";

const DeviceTokenPopup = ({ onClose, token }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [tooltipTitle, setTooltipTitle] = useState("Copy to clipboard");
  const [openTooltip, setOpenTooltip] = useState(false);
  const tokenRef = useRef(null);
  const dispatch = useDispatch();
  const [animate, setAnimate] = useState(false);

  const copyToClipboard = async (code) => {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(code);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      } catch (e) {
        console.error("Error while copying code", e);
      }
    }
  };

  const handleClose = () => {
    setAnimate(true);
    setTimeout(() => {
      onClose();
    }, IntervalConfiguration.intervalMid);
  };

  const handleCopyClick = async () => {
    try {
      const response = await dispatch(checkUsertoken()).unwrap();

      if (response.status) {
        const tokenText = tokenRef.current.innerText;
        await copyToClipboard(tokenText);

        setTooltipTitle("Copied");
        setOpenTooltip(true);

        setTimeout(() => {
          setOpenTooltip(false);
          setTooltipTitle("Copy to clipboard");
        }, 1000);
      }
    } catch (error) {
      console.error("Token Validation Failed");
    }
  };

  const handleBackgroundClick = (e) => {
    if (e.target.className === "device-mainPopup") {
      handleClose();
    }
  };

  return (
    <div
      className="device-mainPopup bg-opacity-dark-opacity bg-PopUp-BackDrop"
      onClick={handleBackgroundClick}
    >
      <div
        className={`token-popup w-small-popup-width min-h-category-popup-height animate-none ${
          animate
            ? "Qmd:animate-slideInFromLeftSmallPopUp"
            : "Qmd:animate-slideInFromRightSmallPopUp"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="token-detail-text text-font-md font-semibold">
          <p>Token details</p>
          <IconRoundButton
            icon={ICONS?.CLOSE}
            handleFunction={handleClose}
            enabledBgColor="var(--primary-nav)"
            hoverOption="white"
          />
          {/* </div> */}
        </div>

        <div className="api-box max-w-[var(--token-width)] w-full rounded-border-radius-md  global-border-dash flex gap-gap-md">
          <p
            ref={tokenRef}
            id="id-firstLetter"
          >
            {token}
          </p>
          <div className="clipboard-img flex flex-shrink-0 items-end">
            <div className="relative flex flex-col items-center justify-center group">
              <div
                className={`absolute top-[var(--top-timeline)] px-padding-sm py-padding-xs text-font-xs text-white bg-black rounded-border-radius-xs whitespace-nowrap transition-opacity duration-animation-fast-xs pointer-events-none z-max-zindex
      ${openTooltip ? "opacity-base-opacity" : "opacity-opacity-none group-hover:opacity-base-opacity"}
    `}
              >
                {tooltipTitle}
              </div>

              <div
                className="bg-primary-nav p-padding-xs rounded-border-radius-xs p-pagination-padding global-hover-white relative z-z-index-base cursor-pointer"
                onClick={handleCopyClick}
                onMouseEnter={() => {
                  if (tooltipTitle !== "Copied") setOpenTooltip(true);
                }}
                onMouseLeave={() => {
                  if (tooltipTitle !== "Copied") setOpenTooltip(false);
                }}
              >
                <SVGComponent
                  url={ICONS.COPY}
                  height="var(--font-md)"
                  width="var(--font-md)"
                />
              </div>
            </div>
          </div>
        </div>

        <p
          className="text-font-xs font-normal font-sans whitespace-normal leading-snug text-text-secondary"
          style={{ overflowWrap: "normal", wordBreak: "keep-all" }}
        >
          Please copy this token as it will not be shown again. <br />
          Incase this token is misplaced, a new token must be generated.
        </p>
      </div>
    </div>
  );
};

export default DeviceTokenPopup;
